import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { firstRoute } from "../lib/perms";

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);
    const [popupDone, setPopupDone] = useState(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = location.hash || window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? match[1] : null;
        if (!sessionId) {
            navigate("/login");
            return;
        }
        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                // Popup flow (embedded in iframe): hand the token back to the opener and close.
                if (window.opener && !window.opener.closed) {
                    window.opener.postMessage({ type: "care:authResult", ok: true, token: data.token }, window.location.origin);
                    setPopupDone(true);
                    window.close();
                    return;
                }
                if (data.token) localStorage.setItem("auth_token", data.token);
                setUser(data);
                window.history.replaceState(null, "", window.location.pathname);
                navigate(firstRoute(data));
            } catch (e) {
                navigate("/login");
            }
        })();
    }, [location, navigate, setUser]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background">
            {popupDone ? (
                <>
                    <p className="text-sm text-foreground">Autenticado com sucesso! Você já pode fechar esta janela.</p>
                    <button onClick={() => window.close()} className="mt-4 rounded-full bg-primary px-5 py-2 text-sm font-medium text-white">Fechar</button>
                </>
            ) : (
                <>
                    <Loader2 className="h-8 w-8 animate-spin text-primary" />
                    <p className="mt-4 text-sm text-muted-foreground">Autenticando com Google...</p>
                </>
            )}
        </div>
    );
}
